import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FeaturedThisWeekService } from 'src/app/services/featured-this-week.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class EditComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  pagetitle: string;
  statuses: any = [];
  featuredThisWeekForm: FormGroup;
  featuredThisWeekStatus: boolean = true;
  notproduct: boolean = false;
  showUploadedpic: boolean = false;
  uploadedFiles: any[] = [];
  featuredThisWeekImages: any[] = [];
  submitted: boolean = false;
  id: any;
  public featuredThisWeekImage: any;
  previousFeaturedThisWeekImageExists: boolean = false;
  serverFeaturedThisWeekImage: any = null;
  showExistingFeaturedImage: boolean = false;
  minYear = environment.minYear;
  yearRange: string;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropDialog: boolean = false;
  selectedFile: File | null = null;
  imageSize = 1000000;
  croppedImageMaxSize = 1000000;
  croppedImageSize = 0;
  croppedImageError: string | null = null;
  scale = 1;
  transform: ImageTransform = {};
  cropApplied = false;
  isApplyingCrop = false;
  isSubmitting = false;
  private acceptedFeaturedFile: File | null = null;
  private previousAcceptedFeaturedFile: File | null = null;
  private previousUploadedFiles: any[] = [];
  private previousFeaturedThisWeekImages: any[] = [];
  private previousDisplayImage: any = null;
  private previousExistingImageExists = false;
  private previousShowExistingImage = false;

  constructor(private formBuilder: FormBuilder, private router: Router, private featuredThisWeekService: FeaturedThisWeekService, private messageService: MessageService,
    private confirmationService: ConfirmationService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.yearRange = this.minYear + ":2030";
    this.pagetitle = 'Edit Featured this week';
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.id = params['id'];
    })
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
    this.featuredThisWeekForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      status: [true, Validators.required],
      link: ['', [Validators.required]],
      description: ['', [Validators.required]], 
      date: [null, [Validators.required]]
    })

    this.getFeaturedThisWeekData(this.id);
  }
  
  getFeaturedThisWeekData(id:string) {    
    this.featuredThisWeekService.getFeaturedThisWeekById(id).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.featuredThisWeekForm.patchValue({
        title: data['title'],
        status: data['status'],
        link: data['link'],
        description: data['description'],
        date: moment(data['date']).toDate()
      })
      if (data['photo'] !== undefined && data['photo'] !== null) {
        this.serverFeaturedThisWeekImage = data['photo'];
        if (!this.acceptedFeaturedFile) {
          this.featuredThisWeekImage = this.serverFeaturedThisWeekImage;
          this.previousFeaturedThisWeekImageExists = true;
          this.showExistingFeaturedImage = true;
        }
      } else {
        this.serverFeaturedThisWeekImage = null;
        if (!this.acceptedFeaturedFile) {
          this.featuredThisWeekImage = null;
          this.previousFeaturedThisWeekImageExists = false;
          this.showExistingFeaturedImage = false;
        }
      }
    })
  }

  get f() {
    return this.featuredThisWeekForm.controls;
  }

  onStatusSelect(event) {
    if (event) {
      this.featuredThisWeekStatus = event.value;
    }
  }

  onFileSelect(event: any) {
    const file = event.files[0];
    if (!file) return;

    this.capturePreviousImage();
    this.cropApplied = false;
    if (file.size > this.imageSize) {
      this.rejectOversizedImage();
      return;
    }

    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = file;
    this.isApplyingCrop = false;
    this.resetZoom();
    const fileEvent: any = {
      target: {
        files: [file]
      }
    };
    this.imageChangedEvent = fileEvent;
    this.cropDialog = true;
  }

  get cropDialogTitle(): string {
    return 'Crop & Adjust Featured Image';
  }

  get cropDialogSubtitle(): string {
    return 'Position and scale your image for a 736 x 840 crop';
  }

  get cropPreviewLabel(): string {
    return '736 x 840 px - High Quality JPEG';
  }

  zoomIn() {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomOut() {
    if (this.scale > 0.2) {
      this.scale -= 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }
  }

  resetZoom() {
    this.scale = 1;
    this.transform = {
      ...this.transform,
      scale: 1
    };
  }


  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
      ? 'Cropped image size must not exceed 1 MB.'
      : null;
  }

  onCropImageLoadFailed() {
    this.croppedImage = null;
    this.croppedImageSize = 0;
    this.croppedImageError = 'This image could not be loaded. Please choose a valid image file.';
  }
    
  getBase64SizeBytes(base64: string): number {
    if (!base64) return 0;
    return Math.round(
      (base64.length * (3 / 4)) -
      (base64.split(',')[0].length + 1)
    );
  }

  applyCrop() {
    if (this.isApplyingCrop || this.croppedImageError || !this.croppedImage || !this.selectedFile) return;
    this.isApplyingCrop = true;
    const file = this.base64ToFile(
      this.croppedImage,
      this.getOutputFileName(this.selectedFile.name)
    );
    if (file.size > this.croppedImageMaxSize) {
      this.croppedImageError = 'Cropped image size must not exceed 1 MB.';
      this.isApplyingCrop = false;
      return;
    }

    (file as any).objectURL = this.croppedImage;
    this.uploadedFiles = [file];
    this.featuredThisWeekImages = [{ file: this.croppedImage }];
    this.acceptedFeaturedFile = file;
    this.featuredThisWeekImage = this.croppedImage;
    this.showExistingFeaturedImage = false;
    this.notproduct = false;
    if (this.fileUpload) {
      this.fileUpload.clear();
      this.fileUpload.files = [file];
    }
    this.cropApplied = true;
    this.cropDialog = false;
  }

  onCropCancel() {
    this.cropApplied = false;
    this.cropDialog = false;
  }

  onDialogHide() {
    if (!this.cropApplied) {
      this.restorePreviousImage();
    }
    this.resetCropState();
  }

  private capturePreviousImage() {
    this.previousUploadedFiles = [...this.uploadedFiles];
    this.previousFeaturedThisWeekImages = [...this.featuredThisWeekImages];
    this.previousAcceptedFeaturedFile = this.acceptedFeaturedFile;
    this.previousDisplayImage = this.featuredThisWeekImage;
    this.previousExistingImageExists = this.previousFeaturedThisWeekImageExists;
    this.previousShowExistingImage = this.showExistingFeaturedImage;
  }

  private restorePreviousImage() {
    this.uploadedFiles = [...this.previousUploadedFiles];
    this.featuredThisWeekImages = [...this.previousFeaturedThisWeekImages];
    this.acceptedFeaturedFile = this.previousAcceptedFeaturedFile;

    if (this.previousAcceptedFeaturedFile) {
      this.featuredThisWeekImage = this.previousDisplayImage;
      this.previousFeaturedThisWeekImageExists = this.previousExistingImageExists;
      this.showExistingFeaturedImage = this.previousShowExistingImage;
    } else if (this.serverFeaturedThisWeekImage) {
      this.featuredThisWeekImage = this.serverFeaturedThisWeekImage;
      this.previousFeaturedThisWeekImageExists = true;
      this.showExistingFeaturedImage = true;
    } else {
      this.featuredThisWeekImage = this.previousDisplayImage;
      this.previousFeaturedThisWeekImageExists = this.previousExistingImageExists;
      this.showExistingFeaturedImage = this.previousShowExistingImage && !!this.previousDisplayImage;
    }

    if (this.fileUpload) {
      this.fileUpload.clear();
      this.fileUpload.files = this.acceptedFeaturedFile ? [this.acceptedFeaturedFile] : [];
    }
  }

  private resetCropState() {
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = null;
    this.previousUploadedFiles = [];
    this.previousFeaturedThisWeekImages = [];
    this.previousAcceptedFeaturedFile = this.acceptedFeaturedFile;
    this.previousDisplayImage = null;
    this.previousExistingImageExists = this.previousFeaturedThisWeekImageExists;
    this.previousShowExistingImage = this.showExistingFeaturedImage;
    this.cropApplied = false;
    this.isApplyingCrop = false;
    this.resetZoom();
  }
    
  rejectOversizedImage() {
    this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image no larger than 1 MB', life: 6000 });
    this.restorePreviousImage();
    this.resetCropState();
  } 

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  picUploader(event) {
    const files: File[] = event?.files || event;
    if (!files || files.length === 0) return;
    const file = files[0];
    this.notproduct = false;
    this.uploadedFiles = [file];
    this.acceptedFeaturedFile = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result != null) {
        this.featuredThisWeekImages = [{ file: reader.result }];
      }
    };
  }

  removeFile(event) {
    this.uploadedFiles = [];
    this.featuredThisWeekImages = [];
    this.acceptedFeaturedFile = null;
    if (this.serverFeaturedThisWeekImage) {
      this.featuredThisWeekImage = this.serverFeaturedThisWeekImage;
      this.previousFeaturedThisWeekImageExists = true;
      this.showExistingFeaturedImage = true;
    } else {
      this.featuredThisWeekImage = null;
      this.previousFeaturedThisWeekImageExists = false;
      this.showExistingFeaturedImage = false;
    }
  }

  removeFeaturedThisWeekImage(): void {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to delete this image ?',
      // header: 'Confirm',
      // icon: 'pi pi-exclamation-triangle',
       message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this image ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 

      accept: () => {
        this.featuredThisWeekImage = null;
        this.serverFeaturedThisWeekImage = null;
        this.previousFeaturedThisWeekImageExists = false;
        this.showExistingFeaturedImage = false;
      },
      reject: () => { }
    });
  }

  onSubmit() {
    if (this.isSubmitting) {
      return;
    }
    this.submitted = true;
    let updateFeaturedThisWeekData = {};
    if (this.featuredThisWeekImages.length === 0 && !this.previousFeaturedThisWeekImageExists) {
      this.notproduct = true;
      return;
    } else {
      this.notproduct = false;
    }

    if (this.featuredThisWeekForm.invalid) {
      return;
    }

    updateFeaturedThisWeekData['title'] = this.featuredThisWeekForm.value.title;
    updateFeaturedThisWeekData['status'] = this.featuredThisWeekForm.value.status;
    updateFeaturedThisWeekData['link'] = this.featuredThisWeekForm.value.link;
    updateFeaturedThisWeekData['description'] = this.featuredThisWeekForm.value.description;
    updateFeaturedThisWeekData['date'] = moment(this.featuredThisWeekForm.value.date, "DD-MM-YYYY").format("YYYY-MM-DD");
    updateFeaturedThisWeekData['photo'] = this.featuredThisWeekImages[0]?.file;

    updateFeaturedThisWeekData = JSON.stringify(updateFeaturedThisWeekData, null, 4);
    this.isSubmitting = true;
    this.featuredThisWeekService.updateFeaturedThisWeek(this.id, updateFeaturedThisWeekData).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Featured this week Updated', life: 6000 });
      setTimeout(() => {
        this.router.navigate(['/manage/featured-this-week']);
      }, 2000);
    }, (error) => {
      this.isSubmitting = false;
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  private getOutputFileName(filename: string | undefined): string {
    const baseName = (filename || 'featured-image').replace(/\.[^/.]+$/, '');
    return `${baseName}.jpg`;
  }

  backLink() {
    this.router.navigate(['/manage/featured-this-week']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
